import styled from '@emotion/styled';

import { authColors, authLayout } from 'design-system/tokens';

export const Options = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: ${authLayout.fieldWidth};

  @media (max-width: ${authLayout.mobileBreakpoint}) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 24px;
    width: 100%;
  }
`;
export const ForgotPasswordLink = styled.a`
  font-family: 'Mangueira', sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  color: ${authColors.brand};

  &:hover {
    color: ${authColors.brand};
    text-decoration: underline;
  }
`;
